import { Icon } from "@mdi/react";
import { mdiCog } from "@mdi/js";
import { useTranslation } from "react-i18next";
import { DropdownMenuItem } from "@acdc2/ui/components/dropdown-menu";
import { Link } from "react-router";
import { routingPaths } from "../navigation/constants";

export function ViewerSettingsDropdownMenuItem() {
  const { t } = useTranslation();

  return (
    <DropdownMenuItem asChild>
      <Link to={routingPaths.settings}>
        <Icon path={mdiCog} size="1.25rem" />
        {t("ViewerSettingsDropdownMenuItem.label")}
      </Link>
    </DropdownMenuItem>
  );
}
